var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !this.is_mem_load
    ? _c("h2", [
        _vm._v("\n    " + _vm._s(_vm.mem_title) + "\n    "),
        _c("sup", [
          _vm.is_cancel
            ? _c("span", { staticClass: "badge badge-danger ml-2" }, [
                _vm._v("(СКАСОВАНА ІНІЦІАТОРОМ!!!)"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.mem_status == -1
            ? _c("span", { staticClass: "badge badge-danger ml-2" }, [
                _vm._v("Службова Видалена"),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }